export { Notifications } from '@smartplatform/consta/ui/Notifications/Notifications';
import {
	addSuccessNotification as addSuccessNotificationBase,
	addAlertNotification as addAlertNotificationBase,
	addWarningNotification as addWarningNotificationBase,
	addNormalNotification as addNormalNotificationBase,
} from '@smartplatform/consta/ui/Notifications/triggers';

const defaultOptions = { autoClose: 5 };

export const addSuccessNotification = (message, options = {}) => {
	addSuccessNotificationBase(message, { ...defaultOptions, ...options });
};

export const addAlertNotification = (message, options = {}) => {
	addAlertNotificationBase(message, { ...defaultOptions, ...options });
};

export const addWarningNotification = (message, options = {}) => {
	addWarningNotificationBase(message, { ...defaultOptions, ...options });
};

export const addNormalNotification = (message, options = {}) => {
	addNormalNotificationBase(message, { ...defaultOptions, ...options });
};
